import { dscvrIcApi } from '@/shared/api';
import type { UserWalletKind } from 'dfx/edge/edge.did';

export const useIcUnpairWalletMutation = (wallet: UserWalletKind) => {
  return dscvrIcApi.wallet.unpairWallet(wallet);
};
